import { registerLocaleData } from "@angular/common";
import { HttpClient, HttpClientModule } from "@angular/common/http";
import localeFr from "@angular/common/locales/fr";
import { LOCALE_ID, NgModule } from "@angular/core";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { ApiService } from "./providers/api/api.service";
import { CustomI18nTranslateLoader } from "./providers/customI18nLoader";

registerLocaleData(localeFr);

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http);
}
@NgModule({
  declarations: [],
  imports: [
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useClass: CustomI18nTranslateLoader,
        deps: [ApiService],
      },
    }),
  ],
  providers: [{ provide: LOCALE_ID, useValue: "fr-FR" }],
  exports: [TranslateModule],
})
export class I18nModule {
  // Do not include a constructor in a module; otherwise, it will short-circuit Angular's initialization flow at the initialization stage.
}
